import { render, staticRenderFns } from "./ReceiptGroupView.vue?vue&type=template&id=30967d44&"
import script from "./ReceiptGroupView.vue?vue&type=script&lang=js&"
export * from "./ReceiptGroupView.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptGroupView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports